import { cn } from "@omni/utils/styles";

import { Spinner } from "@/components/General/Spinner/spinner.component";

export const SearchResultsSkeleton = () => {
    return (
        <div
            id={"search__loading"}
            className={cn("tw:w-full tw:h-dvh")}
        >
            <div
                className={cn(
                    "tw:w-full tw:h-dvh tw:flex tw:items-center tw:flex-col tw:justify-center tw:z-200 tw:fixed tw:top-0 tw:left-0 tw:bg-white"
                )}
            >
                <Spinner />
            </div>
        </div>
    );
};
